import { actions, loaders } from 'entities';

import { useFocusedUser } from '../../focusedUser.hook';
import { Alert, Card, Column, IconButton, LabeledSelect, Row, Skeleton } from 'components/Blocks';
import { compareByName, listGet, sortByProperty } from 'utils/array';
import { TrashIcon } from 'components/Icons';
import { useLang } from 'hooks';

export function SecondaryTeams() {
  const { t } = useLang();

  const { focusId } = useFocusedUser();

  const [user, userState] = loaders.users.find.useV2({
    params: { id: focusId },
    blockLoad: !focusId,
  });

  const [teams, teamsState] = loaders.teams.list.useV2({
    defaultValue: [],
  });

  const toggleTeam = actions.users.toggleSecondaryTeam.use({
    onSuccess: (updatedTeams, { userId }) => {
      userState.overwrite((old) =>
        old.id === userId ? { ...old, secondaryTeams: updatedTeams.secondaryTeams } : old,
      );
    },
  });

  if (!user || userState.errorOrLoading || teamsState.errorOrLoading)
    return <Skeleton quantity={4} height={40} />;

  const secondaryTeams = (user.secondaryTeams || [])
    .map((data) => ({
      ...data,
      team: listGet(teams, data.id)!,
    }))
    .filter((t) => t.team);

  return (
    <Column gap="6">
      <Alert title={t('user-will-have-full-access')} level="warning">
        {t('every-action-available')}
      </Alert>

      <LabeledSelect
        label={t('team')}
        labelKey="name"
        options={teams.filter((t) => !listGet(secondaryTeams, t.id) && t.id !== user.team.id)}
        loading={toggleTeam.loading}
        onChangeDirect={(teamId) =>
          toggleTeam.execute({
            userId: focusId,
            teamId,
          })
        }
      />

      <Column>
        {sortByProperty(secondaryTeams, 'team', { team: (a, b) => compareByName(a, b) }).map(
          (secondary) => (
            <Card key={secondary.id}>
              <Row justifyContent="space-between">
                <span>{secondary.team.name}</span>

                <IconButton
                  loading={toggleTeam.loading}
                  onClick={() =>
                    toggleTeam.execute({
                      userId: focusId,
                      teamId: secondary.id,
                    })
                  }
                >
                  <TrashIcon size={16} />
                </IconButton>
              </Row>
            </Card>
          ),
        )}
      </Column>
    </Column>
  );
}
